import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";


export class ProjectSelectListComponent implements IController {

  selectedId: any;
  from: number;
  to: number;
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;


  private planningProjectsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  public excludedMap: any;

  /* @ngInject */
  constructor(private $planningProjects, private $infiniteScroll, private $log) {
    this.planningProjectsRef = this.$planningProjects();
  }

  $onInit() {

    this.loadLimit = 20;
    this.planningProjectsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.planningProjectsRef, this.loadLimit, {getFullData: true});

  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }



  private _reload() {
    this.planningProjectsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      from: this.from,
      to: this.to,
      limit: this.loadLimit
    }
  }
}

angular
  .module('bringoz.admin.planning')
  .component('projectSelectList', {
    bindings: {
      selectedId: '<',
      from: '<',
      to: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./project-select-list.html').default,
    controller: ProjectSelectListComponent
  });
